<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'App',
  
  computed: {
    ...mapState('account', ['user', 'status']),
    ...mapState('ws', ['wsState'])
  },

  watch: {
    // ��ť�Τ�n�J���A�A�۰ʪ�l�� WebSocket
    user: {
      handler(newUser) {
        if (newUser && newUser.data && newUser.data.user && this.status?.token) {
          // �Τ�w�n�J�B�� token�A��l�ƥ��� WebSocket
          this.$nextTick(() => {
            this.initWebsocket();
          });
        } else {
          // �Τ�n�X�A���� WebSocket
          this.closeWebSocket();
        }
      },
      immediate: true,
      deep: true
    }
  },

  methods: {
    ...mapActions('ws', ['initWebsocket', 'closeWebSocket'])
  },

  beforeDestroy() {
    // App �P������������ WebSocket
    this.closeWebSocket();
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}


</style>
